import React from 'react';
import { Link } from 'react-router-dom';
import './StatsHero.css';

// Import the new decorative graphic
import graphicImg from '../../assets/images/stats-hero-graphic.png';

const StatsHero = () => {
  return (
    <section className="stats-hero-section">
      {/* Left Column: Text Content */}
      <div className="stats-hero-content">
        <h1>Empowering business decisions through data & insights</h1>
        <p>
          Access reliable price data, trade flows, production, and inventory figures, all backed by 20+ years of history and validated by industry experts.
        </p>
        <Link to="/signup">
          <button className="cta-button secondary-outline">Book a demo</button>
        </Link>
      </div>

      {/* Right Column: Image */}
      <div className="stats-hero-graphic">
        <img src={graphicImg} alt="Data and Insights Graphic" />
      </div>
    </section>
  );
};

export default StatsHero;